import React from 'react';

interface LanguageSwitcherProps {
  current: string;
  onSwitch: (lang: string) => void;
}

// Language endonyms - shown in their own language, never translated
const LANGUAGES: { code: string; label: string }[] = [
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
  { code: 'he', label: 'עברית' },
];

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ current, onSwitch }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 0,
        fontSize: '15px',
        background: 'rgba(128, 128, 128, 0.12)',
        borderRadius: 'var(--kol-radius-full, 9999px)',
        padding: '4px',
        // Fixed order regardless of UI language so the pill matches the design in RTL too
        direction: 'ltr',
      }}
    >
      {LANGUAGES.map(({ code, label }) => {
        const isActive = current === code;
        return (
          <button
            key={code}
            type="button"
            style={{
              background: isActive ? '#3F4756' : 'transparent',
              border: 'none',
              color: isActive ? '#FFFFFF' : '#6B7280',
              cursor: 'pointer',
              padding: '8px 14px',
              borderRadius: 'var(--kol-radius-full, 9999px)',
              fontWeight: isActive ? 500 : 400,
              whiteSpace: 'nowrap',
              transition: 'all 0.2s ease',
            }}
            onClick={() => onSwitch(code)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
